//
//
//
//
import ExceptionPage from './ExceptionPage';
export default {
  name: '404',
  components: {
    ExceptionPage: ExceptionPage
  }
};